import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { Note, NOTE_TYPE } from "../../../../../components/note/note";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    noneRestockableItemsCount: number,
    selectedItemsCount: number,
}

const RestockNote: React.FC<IProps> = ({noneRestockableItemsCount, selectedItemsCount}) => {

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-page';
    const restockNoteText = `${noneRestockableItemsCount} ${getTranslation('RESTOCK_TOGGLE_INFO_NOTE1', pageScope)} ${selectedItemsCount - noneRestockableItemsCount} ${getTranslation('RESTOCK_TOGGLE_INFO_NOTE2', pageScope)}`;

    return (
        <Note type={NOTE_TYPE.INFORMATION} body={<FontBody2>{restockNoteText}</FontBody2>} />
    );


}

export default RestockNote;